const { $ } = window;

$(() => {
  $('#weight-classes').on('change', function callback() {
    const $this = $(this);
    const section = $this.val();
    if (section !== '') {
      $('body, html').animate({
        scrollTop: $(`#${section}`).offset().top - $this.parent().parent().outerHeight(true) - $('#fixed-adder').outerHeight(true) - parseInt($('.body-container').css('paddingTop'), 10) - 16,
      });
    }
  });

  $('body').on('scrolled-to-top', () => {
    $('#weight-classes').val('');
  });
});
